<template>
  <div >
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="物料编码">
              <el-input v-model="q.materialCode" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="客户编码">
              <el-input v-model="q.customerCode" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="国际条款">
              <mdmselect clearable category="YlCommercialTerms" :v="q.gjmytk"
                         :showcode="true"
                         v-model="q.gjmytk"></mdmselect>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="q.status" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in category1AllList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="queryPage">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button
                class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                @click="createOrderSalsePrice" >新增产品
            </el-button>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30">
        <el-button
            class="h-btn h-formBtn h-bggreen" style="margin-bottom: 20px"
            @click="multipleItems" >重新提交
        </el-button>
        <el-table
            ref="ddtable"
            :data="tableData"
            @selection-change="handleSelectionChange"
            stripe
            border
            style="width: 100%">
          <el-table-column
              type="selection"
              fixed
              :selectable="optionData"
              width="40">
          </el-table-column>
          <el-table-column
              type="index"
              width="40"
              label="序号"
              fixed >
          </el-table-column>
          <el-table-column
              prop="materialCode"
              label="物料编码"
              :show-overflow-tooltip="true"
              width="120">
          </el-table-column>
          <el-table-column
              prop="materialName"
              label="物料名称"
              show-overflow-tooltip
              width="120">
          </el-table-column>
          <el-table-column
              prop="currency"
              label="币种"
              width="120">
            <template slot-scope="scope">
              {{scope.row.currency | dictname('YLCurrency')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="unitPrice"
              label="单价"
              :show-overflow-tooltip="true"
              width="120">
          </el-table-column>
          <el-table-column
              prop="gjmytk"
              label="国际贸易条款"
              width="80">
          </el-table-column>
          <el-table-column
              prop="customerCode"
              label="客户编码"
              width="150">
          </el-table-column>
          <el-table-column
              prop="customerName"
              label="客户名称"
              show-overflow-tooltip
              width="150">
          </el-table-column>
          <el-table-column
              prop="effectiveDate"
              label="有效日期"
              :formatter="formatDatecc"
              width="110">
          </el-table-column>
          <el-table-column
              prop="status"
              label="价格状态"
              width="110">
            <template scope="scope">
              {{scope.row.status|dictname('bsc_order_salse_price')}}
            </template>
          </el-table-column>
          <el-table-column
              prop="cuname"
              label="创建人名称"
              width="110">
          </el-table-column>
          <el-table-column
              prop="cdate"
              label="创建时间"
              :formatter="formatDatecc"
              width="110">
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="150" >
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button
                    v-if="null != scope.row.instId && '' != scope.row.instId"
                    type="text"
                    size="small"
                    class="h-tableLink h-btn"
                    @click="genzongLiuch(scope.row)">
                  跟踪
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    @click="toChange(scope.row)"
                    class="h-tableLink h-btn">
                  编辑
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn"
                    @click="toSee(scope.row)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" v-auth="'downloadSalsePrice'"
                       @click="downloadExcel">批量导出
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportModel">导出模版
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导入
            </el-button>
            <uploaddownexcel
                :visible.sync="uploaddownexcelflag"
                v-if="uploaddownexcelflag"
                clsname="bscOrderSalsePriceExcel"
                :startrow="1"
                @callback="uploadExcelFilecallback"/>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="queryPage" />
          </div>
        </div>
        <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
          <div class="h-dialogImg">
            <div class="h-disTable">
              <div class="h-tableCell">
                <h1>{{titleDig}}</h1>
              </div>
            </div>
          </div>
          <div class="h-formLines">
            <el-form ref="form" :model="addOrderSalsePrice" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
              <el-form-item label="物料编码" class="h-elformWrap-2" prop="materialCode" :rules="[{ required: true, message: '请输入物料编码', trigger: 'blur'},]">
                <el-input v-model="addOrderSalsePrice.materialCode" style="width: 84%;" clearable @blur="salesSamplelistF()"></el-input>
              </el-form-item>
              <el-form-item  label="物料名称" class="h-elformWrap-2" label-width="100" prop="materialName" :rules="[{ required: true, message: '请输入物料名称', trigger: 'blur'},]">
                <el-input v-model="addOrderSalsePrice.materialName" style="width: 84%;" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="币种" class="h-elformWrap-2" prop="currency" :rules="[{ required: true, message: '请选择币种', trigger: 'blur'},]">
                <brselect category="YLCurrency" :v="addOrderSalsePrice.currency" v-model="addOrderSalsePrice.currency" :clearable="true" :disabled="false"/>
              </el-form-item>
              <el-form-item  label="单价" class="h-elformWrap-2" label-width="100" prop="unitPrice" :rules="[{ required: true, message: '请输入单价', trigger: 'blur'},]">
                <el-input v-model="addOrderSalsePrice.unitPrice" style="width: 84%;" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户名称" class="h-elformWrap-2" :rules="[{ required: true, message: '请选择客户', trigger: 'blur'},]" prop="customerCode">
                <el-select placeholder="请选择" filterable clearable allow-create v-model="addOrderSalsePrice.customerCode" @change="fillCusName1" id="customer">
                  <el-option v-for="customer in customerList" :key="customer.usercode" :label="customer.username+'-'+customer.usercode" :value="customer.usercode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="有效日期" :rules="[{ required: true, message: '请选择日期', trigger: 'blur'},]" class="h-elformWrap-2" prop="effectiveDate">
                <el-date-picker
                    style="width: 84%;"
                    v-model="addOrderSalsePrice.effectiveDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="有效日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item  label="国际贸易条款" class="h-elformWrap-2" label-width="100" prop="gjmytk" :rules="[{ required: true, message: '请输入国际贸易条款', trigger: 'blur'},]">
                <el-select v-model="addOrderSalsePrice.gjmytk" filterable
                           :placeholder="'--选择--'"
                           clearable
                           @change="gjmytkchanges"
                           style="width:100%">
                  <el-option
                      v-for="(item,index) in optionLists"
                      :key="index"
                      :label="`[${item.code}]${item.name}`"
                      :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="display:flex;justify-content:center;margin-bottom:20px">
              <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
              <el-button class="h-btn h-bBtn h-bgblueQ2" @click="save">提交</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>
<script>
  import orderSalsePrice from "../../../api/reform/orderSalsePrice.js";
  import ss from "../../../api/SystemService";
  import updownfile from "@/utils/updownfile";
  import uploaddownexcel from "@/components/uploaddown/uploaddownexcel.vue";
  export default {
    components: {uploaddownexcel},
    data() {
      return {
        q:{
          //物料编码
          materialCode:null,
          //产品大类
          prodseries:null,
          //创建人
          cucode:null,
          status:null,
          //客户编码
          customerCode:null,
          //国际条款
          gjmytk:null,
          delflag:1,
          pageSize:10,
          pageNo:1,
          total:0,
        },
        tableData:[],
        bscOrderSalsePrice:{

        },
        //弹框新增
        newDialog:false,
        instid:null,
        showhistory:false,
        multipleData:[],
        titleDig:"",
        addOrderSalsePrice:{
          id:null,
          cucode:null,
          cuname:null,
          cdate:null,
          lucode:null,
          ldate:null,
          delflag:null,
          materialCode:null,//物料编码
          materialName:null,//物料名称
          currency:null,//币种
          unitPrice:null,//单价
          prodseries:null,//系列（产品大类）
          oneLid:null,//大类编码
          customerCode:null,//客户编码
          customerName:null,//客户名称
          effectiveDate:null,//有效日期
          gjmytk:null,//国际贸易条款
        },
        //客户集合
        customerList:[],
        //国际贸易条款
        optionLists:[],
        uploaddownexcelflag:false,
        category1AllList:[],
      }
    },
    created() {
      this.queryPage();
      this.getCustomerList();
      ss.Dictservice.listMdmbycategory("YlCommercialTerms").then(rd=>{
        this.optionLists = _.filter(rd,(o) => {
          return _.includes('DDP,FOB',o.code)
        });
      })
      this.category1AllList= this.$store.getters.dictlist("bsc_order_salse_price");
    },
    methods: {
      /**
       * 客户集合
       */
      getCustomerList(){
        ss.contractService.getCustomerList({usertype:1,delflag:1}).then(rd=>{
              this.customerList =  _.filter(rd,(o) => {
                return _.includes('9100001625,9100001809',o.usercode)
              });
        });
      },
      /**
       * 查询
       */
      queryPage() {
        orderSalsePrice.selecPage(this.q).then(res => {
          this.q.total = res.total;
          this.tableData = res.records;
        })
      },
      /**
       * 重置查询
       */
      resetData(){
        var pageSize=this.q.pageSize;
        var pageNo=this.q.pageNo;
        var total=this.q.total;
        this.q= {
          //物料编码
          materialCode:null,
          //产品大类
          prodseries:null,
          //创建人
          cucode:null,
          status:null,
          gjmytk:null,
          delflag:1,
          customerCode:null,
          pageSize: pageSize,
          pageNo: pageNo,
          total:total,
        }
        this.queryPage();
      },
      /**
       * 凭证过账日期格式化
       * @param row
       * @param column
       * @returns {string|null}
       */
      formatDatecc(row, column) {
        // 获取单元格数据
        let data = row[column.property]
        if(data == null || data == '') {
          return null
        }
        let dt = new Date(data)
        return this.$util.riQi3(dt);
      },
      /**
       * 编辑
       */
      toChange(row){
        orderSalsePrice.selectById(row.id).then(res => {
          if (res.f){
            this.addOrderSalsePrice = res.obj;
            this.titleDig = "修改产品"
            this.newDialog = true
          }else {
            this.$msg.msge("获取信息失败!");
          }
        })
      },
      genzongLiuch(r) {
        console.log(r);
        this.instid = r.instId;
        this.showhistory = true;
      },
      /**
       * 删除
       * @param row
       */
      toSee(row){
        orderSalsePrice.deleteById(row.id).then(res => {
          if (res.f){
            this.$alert("删除成功", '提示', {
              confirmButtonText: '确定',
            });
            this.queryPage();
          }else {
            this.$msg.msge("删除失败!");
          }
        })
      },
      createOrderSalsePrice(){
        this.titleDig = "新增产品";
        this.newDialog = true;
      },
      closeDialog(){
        this.newDialog = false;
        this.addOrderSalsePrice = {
          id:null,
          cucode:null,
          cuname:null,
          cdate:null,
          lucode:null,
          ldate:null,
          delflag:null,
          materialCode:null,//物料编码
          materialName:null,//物料名称
          currency:null,//币种
          unitPrice:null,//单价
          prodseries:null,//系列（产品大类）
          oneLid:null,//大类编码
          customerCode:null,//客户编码
          customerName:null,//客户名称
          effectiveDate:null,//有效日期
          gjmytk:null,//国际贸易条款
        }
      },
      /**
       * 导出明细
       */
      exportExcel(){
        this.uploaddownexcelflag = true;
      },
      uploadExcelFilecallback(rd) {
        this.queryPage();
        this.$msg.msgs(rd.msg);
      },
      downloadExcel(){
        updownfile.down("/api/swyl/v1/demo/bscOrderSalsePrice/downloadExcel", this.q, "post");
      },
      /**
       * 下载模版
       */
      exportModel(){
        updownfile.down("/api/swyl/v1/demo/bscOrderSalsePrice/downloadModel", this.q, "post", 'data');
      },
      /**
       * 选择客户
       * @param data
       */
      fillCusName1(data){
        let obj = {};
        obj = this.customerList.find((item)=>{
          return item.usercode === data;
        });
        console.log(obj,"obj")
        if(obj != undefined ){
          this.addOrderSalsePrice.customerCode = obj.usercode;
          this.addOrderSalsePrice.customerName = obj.username;
        }else {
          this.addOrderSalsePrice.customerCode = null;
          this.addOrderSalsePrice.customerName = null;
        }
      },
      /**
       * 输入物料编码校验信息
       */
      salesSamplelistF(){
        console.log(this.addOrderSalsePrice.materialCode);
        ss.salesListF.selectModel(this.addOrderSalsePrice.materialCode).then(rd => {
          if(rd){
            this.addOrderSalsePrice.materialName = rd.promodel
          }else{
            this.$msg.msge("该物料在销售样表中不存在请确认!");
          }


        })
      },
      //取消
      exit() {
        this.closeDialog()
      },
      gjmytkchanges(v){
        console.log(v)
      },
      save(){
        if ('修改产品' == this.titleDig){
          orderSalsePrice.updateById(this.addOrderSalsePrice).then(res => {
            if (res.f){
              this.$alert("修改成功", '提示', {
                confirmButtonText: '确定',
              });
              this.newDialog = false;
              this.queryPage();
            }else {
              this.$msg.msge(res.msg);
            }
          })
        }else if ('新增产品' == this.titleDig){
          orderSalsePrice.insert(this.addOrderSalsePrice).then(res => {
            if (res.f){
              this.$alert("保存成功", '提示', {
                confirmButtonText: '确定',
              });
              this.newDialog = false;
              this.queryPage();
            }else {
              this.$msg.msge(res.msg);
            }
          })
        }
        },
      handleSelectionChange(lists){
          console.log(lists)
        this.multipleData = lists;
      },
      multipleItems(){
        orderSalsePrice.multipleItems(this.multipleData).then(res => {
          if (res.f){
            this.$alert("提交成功", '提示', {
              confirmButtonText: '确定',
            });
            this.queryPage();
          }else {
            this.$msg.msge(res.msg);
          }
        })
      },
      optionData(row){
        if ("3" == row.status)
          return true
      },
    },
  }
</script>
<style scoped>

</style>